import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "#FFF",
            d: "M9.93 1.525l11.933 11.934c.39.39.39 1.023 0 1.414l-7.071 7.071c-.39.39-1.024.39-1.414 0L1.445 10.012c-.25-.25-.35-.614-.26-.957L2.638 3.41c.091-.354.368-.63.722-.72l5.615-1.427c.341-.087.704.013.953.262zm-.862 1.261l-5.05 1.285-1.31 5.082L14.083 20.53l6.364-6.364-11.38-11.38zM7 5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z",
            transform: "translate(-20 -72) translate(20 72)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }